// src/data/clientsMH.js
// ➜ Ajoute/édite ici les projets/clients pour maximeh.lu
// - code       : mot de passe à donner au client (insensible à la casse)
// - pcloudLink : lien partagé pCloud (ou autre galerie externe)
// - zip        : (optionnel) lien directe ZIP si tu veux proposer le téléchargement

const CLIENTS_MH = [
  {
    id: "projet_demo",
    name: "Projet Démo",
    code: "MH_0000",
    pcloudLink: "https://e.pcloud.link/publink/show?code=VOTRE_CODE_Pcloud",
    zip: "" // par ex. "https://.../projet_demo.zip"
  },
  {
    id: "chez_doudou",
    name: "Chez Doudou",
    code: "CD_2507",
    pcloudLink: "https://e.pcloud.link/publink/show?code=VOTRE_CODE_Pcloud",
    zip: "" // par ex. "https://.../projet_demo.zip"
  },
  {
    id: "les_roses",
    name: "Les Roses - Casino 2000",
    code: "LR_2407",
    pcloudLink: "https://e.pcloud.link/publink/show?code=kZiULOZmIKhICxurnuykqg0tUX9gJ7n0aFy",
    zip: "" // par ex. "https://.../projet_demo.zip"
  },
  {
    id: "radp",
    name: "RADAP",
    code: "RADP_2507",
    pcloudLink: "https://e.pcloud.link/publink/show?code=kZ53LOZFeXyyOUnSg816tWY8XoAd4qMH7Yk",
    zip: "" // par ex. "https://.../projet_demo.zip"
  },
  {
    id: "clovis_degrave_&_françois_jagut",
    name: "Mastercard Masterclass BGL - Clovis DEGRAVE & François JAGUT",
    code: "GM_0605",
    pcloudLink: "https://e.pcloud.link/publink/show?code=kZBrLOZ3FDlXSrAvd5s0Fuw1qny2ktJ7Te7",
    zip: "" // par ex. "https://.../projet_demo.zip"
  },
  {
    id: "clovis_degrave_&_roberto_fani",
    name: "MASTERCARD MASTERCLASS BGL - CLOVIS DEGRAVE & ROBERTO FANI",
    code: "GM_3006",
    pcloudLink: "https://e.pcloud.link/publink/show?code=kZNy4OZrPRsBUmYzSmPgYer499ix5DQYi5y",
    zip: "" // par ex. "https://.../projet_demo.zip"
  },
  {
    id: "radp",
    name: "RADP - MENU ÉTÉ",
    code: "RADP_2806",
    pcloudLink: "https://e.pcloud.link/publink/show?code=kZsX4OZflK0V52YOSjXW8cXHPB50jGrhK6y",
    zip: "" // par ex. "https://.../projet_demo.zip"
  },
  {
    id: "lhetre_beim_musee",
    name: "L'HÊTRE BEIM MUSÉE",
    code: "HBM_1706",
    pcloudLink: "https://e.pcloud.link/publink/show?code=kZ8p4OZD0L1Vu4uhjyKCL6ksyWLxRfhPTIy",
    zip: "" // par ex. "https://.../projet_demo.zip"
  },
  {
    id: "clovis_degrave_&_cyril_molard",
    name: "Mastercard Masterclass BGL - Clovis DEGRAVE & Cyril MOLARD",
    code: "GM_1606",
    pcloudLink: "https://e.pcloud.link/publink/show?code=kZeL4OZBLEF30dhwV8UYGs3OEOLU0NogoqV",
    zip: "" // par ex. "https://.../projet_demo.zip"
  },
  {
    id: "les_roses",
    name: "Les Roses - Casino 2000",
    code: "LR_1606",
    pcloudLink: "https://e.pcloud.link/publink/show?code=kZB84OZvygaBmTpkjQ7susaptrWnzWlpMvV",
    zip: "" // par ex. "https://.../projet_demo.zip"
  },
  {
    id: "gala_les_disciples_escoffier",
    name: "Gala - Les Disciples Escoffier",
    code: "GDE_2105",
    pcloudLink: "https://e.pcloud.link/publink/show?code=kZJb4OZhoiCG2fFVfLDI23nEdFQ9ua5PiuX",
    zip: "" // par ex. "https://.../projet_demo.zip"
  },
  {
    id: "clovis_degrave_&_louis_linster",
    name: "Mastercar Masterclass BGL - Clovis DEGRAVE & Louis LINSTER",
    code: "GM_1905",
    pcloudLink: "https://e.pcloud.link/publink/show?code=kZSE4OZ20acPUYMYtYuzVfNv7sKY5MNqMlX",
    zip: "" // par ex. "https://.../projet_demo.zip"
  },
  {
    id: "radp",
    name: "RADP - Menu Printemps",
    code: "ADB_1705",
    pcloudLink: "https://e.pcloud.link/publink/show?code=kZ8O4OZR9jHqc5UPcQBDL0AvepODVtKXbzV",
    zip: "" // par ex. "https://.../projet_demo.zip"
  },
  {
    id: "radp",
    name: "RADP - Menu Printemps",
    code: "ADB_1705",
    pcloudLink: "https://e.pcloud.link/publink/show?code=kZ8O4OZR9jHqc5UPcQBDL0AvepODVtKXbzV",
    zip: "" // par ex. "https://.../projet_demo.zip"
  },
  {
    id: "chez_doudou",
    name: "Chez Doudou",
    code: "CD_1509",
    pcloudLink: "https://e.pcloud.link/publink/show?code=kZUFyUZrzmPAglv0hmSnyNfq83MiSJJTdKy",
    zip: "" // par ex. "https://.../projet_demo.zip"
  },
  {
    id: "RADP",
    name: "RADP - Mouton Rothschild",
    code: "ADB_2209",
    pcloudLink: "https://e.pcloud.link/publink/show?code=kZdDHUZFHtuFBQY41hjFxKoIN1yIfSUfBY7",
    zip: "" // par ex. "https://.../projet_demo.zip"
  },
  {
    id: "GCT",
    name: "Grunewald Chef's Table",
    code: "GCT_2509",
    pcloudLink: "https://e.pcloud.link/publink/show?code=kZ0mfUZeGNTj5tsyGFRurnuKgGxaJJLogEk",
    zip: "" // par ex. "https://.../projet_demo.zip"
  },
  {
    id: "Marcotullio",
    name: "Marco'Buro by Marcotullio - Carte automne/hiver",
    code: "MB_1001",
    pcloudLink: "https://e.pcloud.link/publink/show?code=kZocTUZXaQVhkEd6H8t0LzWrhGvw4oJ8k2k",
    zip: "" // par ex. "https://.../projet_demo.zip"
  },
  {
    id: "RADP",
    name: "Archibald de Prince - Le Garage à Manger - Land Rover Louyet Habay",
    code: "LR_1410",
    pcloudLink: "https://e.pcloud.link/publink/show?code=kZRC3UZEa8wsVJjVYpE07uWx1h3lH79Mx3k",
    zip: "" // par ex. "https://.../projet_demo.zip"
  },
  {
    id: "Millessence",
    name: "Restaurant Millessence",
    code: "CG_1710",
    pcloudLink: "https://e.pcloud.link/publink/show?code=kZ1EFIZehEEnSdbjeuCI3fTvt6vrkIVnBAy",
    zip: "" // par ex. "https://.../projet_demo.zip"
  },
  {
    id: "les_roses",
    name: "Les Roses - Casino 2000",
    code: "LR_2010",
    pcloudLink: "https://e.pcloud.link/publink/show?code=kZpVHIZucAJxihFhcm7UexfyixGQJU60qqX",
    zip: "" // par ex. "https://.../projet_demo.zip"
  },
  {
    id: "GM_2026",
    name: "Gala Gault&Millau Luxembourg 2026",
    code: "GM_2710",
    pcloudLink: "https://e.pcloud.link/publink/show?code=kZUHSIZCMeLLlyXT8y3Vkyc9cGIo7Et60cVX",
    zip: "" // par ex. "https://.../projet_demo.zip"
  },
  {
    id: "RADP",
    name: "Archibald de Prince - Menu automne",
    code: "RADP_2310",
    pcloudLink: "https://e.pcloud.link/publink/show?code=kZd9jIZs6i7TyeL2BFXtSMbDsdDyJ8BgyjX",
    zip: "" // par ex. "https://.../projet_demo.zip"
  },
  {
    id: "Destination_Nancy",
    name: "Salon Délices & Saveurs - Destination Nancy",
    code: "DN_2610",
    pcloudLink: "https://e.pcloud.link/publink/show?code=kZxF2IZOXNTmmnKpQ8KsnqeAfQRr8Yv1PRV",
    zip: "" // par ex. "https://.../projet_demo.zip"
  },
  {
    id: "Aurélien DE NOBLE",
    name: "Concours Prosper Montagné - Aurélien DE NOBLE",
    code: "ADN_0411",
    pcloudLink: "https://e.pcloud.link/publink/show?code=kZEAMIZ6Jga5utTtPFtcTfCxrFrTpoQccYV",
    zip: "" // par ex. "https://.../projet_demo.zip"
  },
  {
    id: "Great_traiteur",
    name: "Great Traiteur - Evènement du 05 novembre à l'Hotel des Douanes",
    code: "GT_0511",
    pcloudLink: "https://e.pcloud.link/publink/show?code=kZJ6EIZESDuH5jetI0fbWpup0kxgHEvqc3k",
    zip: "" // par ex. "https://.../projet_demo.zip"
  },
  {
    id: "ChefsTable_Hostellerie",
    name: "Grunewald Chef's Table & Hostellerie du Grunewald",
    code: "GCT_1111",
    pcloudLink: "https://e.pcloud.link/publink/show?code=kZMAGIZQBo3ml7eMyYJMqmt2HDOajSozJ6X",
    zip: "" // par ex. "https://.../projet_demo.zip"
  },
  {
    id: "chez_doudou",
    name: "Chez Doudou",
    code: "CD_1711",
    pcloudLink: "https://e.pcloud.link/publink/show?code=kZIYVAZpLPKMVzAf3y7TP8PWiyh6RHu5nty",
    zip: "" // par ex. "https://.../projet_demo.zip"
  },
  {
    id: "julien_eco_cuisine",
    name: "Atelier de pâtisserie par Julien chez Eco Cuisine Houdemont",
    code: "EC_1511",
    pcloudLink: "https://e.pcloud.link/publink/show?code=kZvKJAZulcusfL1jDYyPTMf321UJ59zkQoy",
    zip: "" // par ex. "https://.../projet_demo.zip"
  },
  {
    id: "Marcotullio",
    name: "Diner de la Truffe - Abbaye des Prémontrés - Martocullio",
    code: "MT_1511",
    pcloudLink: "https://e.pcloud.link/publink/show?code=kZETLAZvG7Xf9UOfO8iEN1J8qsUnLpMkisX",
    zip: "" // par ex. "https://.../projet_demo.zip"
  },
  {
    id: "RADP",
    name: "Diner à 6 mains - Archibald, Anthony & Paul",
    code: "RADP_1611",
    pcloudLink: "https://e.pcloud.link/publink/show?code=kZWRbAZ0rO8zxzkjC0upbSoUI20lR4izqCV",
    zip: "" // par ex. "https://.../projet_demo.zip"
  },
  {
    id: "DE",
    name: "Gala Disciples Escoffier Luxembourg 2025",
    code: "DE_1911",
    pcloudLink: "https://e.pcloud.link/publink/show?code=kZ1I2AZ1wY3mT4qU9mtC0NAOYD61hKFazjy",
    zip: "" // par ex. "https://.../projet_demo.zip"
  },
    {
    id: "AV",
    name: "Restaurant Attablez-Vous",
    code: "AV_1012",
    pcloudLink: "https://e.pcloud.link/publink/show?code=kZtyyNZLeb3A73l58RI182rmkB9aXoJGhsk",
    zip: "" // par ex. "https://.../projet_demo.zip"
  },
  {
    id: "RADP",
    name: "Land Rover Niederkorn",
    code: "RADP_1201",
    pcloudLink: "https://e.pcloud.link/publink/show?code=kZ8G7aZV5DIAHcgqDBxPjgpa0FLfJio9J1k",
    zip: "" // par ex. "https://.../projet_demo.zip"
  },
];

export default CLIENTS_MH;